// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Home from './Pages/Home';

import Header from './Components/Header';
import PrivateRoute from './Components/PrivateRoute'; // Protect routes
import Login from './Components/Login';
import ProductSearchScan from './Components/ProductSearchScan';
import InvoiceForm from './Components/InvoiceForm';
import Products from './Components/Products';
import InvoiceView from './Components/InvoiceView';
import MasterReport from './Components/MasterReport';

function App() {
  return (
    <Router>
      <div>
      <Header />

      <div className='content'>          
      {/* <h3 className='tx-center'>Welcome! TJD STOCK Management</h3> */}
        <Routes>

        <Route path="/login" element={<Login />} />


          <Route path="/ProductSearchScan" element={<PrivateRoute><ProductSearchScan /></PrivateRoute>} />
          <Route path="/InvoiceForm" element={<PrivateRoute><InvoiceForm /></PrivateRoute>} />
          <Route path="/Products" element={<PrivateRoute><Products /></PrivateRoute>} />
        <Route path="/Invoiceview" element={<InvoiceView />} />
        <Route path="/MasterReport" element={<MasterReport />} />        

        </Routes>
        </div>
        
      </div>
    </Router>

  );
}

export default App;
